<template>
  <div class="mcp-page">
    <!-- Header -->
    <header class="mcp-header" :class="{ 'scrolled': headerScrolled }">
      <div class="header-wrapper">
        <div class="logo-box">
          <a href="https://www.cricketapi.com" title="Cricket API">
            <img
              class="logo"
              src="@/assets/rca-logo.svg"
              alt="Cricket API Logo"
            />
          </a>
        </div>
        <nav class="header-nav">
          <a
            href="https://www.cricketapi.com/v5/about-us"
            target="_blank"
            class="nav-btn nav-btn--outline"
          >
            <span>About</span>
            <svg
              class="nav-arrow"
              width="4"
              height="8"
              viewBox="0 0 4 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 0.5L3.5 4L0.5 7.5"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
          <a
            :href="calUrl"
            target="_blank"
            class="nav-btn nav-btn--filled"
            @click="onHeaderDemoClick"
          >
            <span>Book a Demo</span>
            <svg
              class="nav-arrow"
              width="4"
              height="8"
              viewBox="0 0 4 8"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.5 0.5L3.5 4L0.5 7.5"
                stroke="white"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </a>
        </nav>
      </div>
    </header>

    <router-view></router-view>

    <!-- Footer Section -->
    <footer class="mcp-footer">
      <div class="footer-content">
        <div class="footer-text">
          <h2 class="footer-title">
            The AI era of cricket
            <br class="desktop-br" />
            is here. Be first.
          </h2>
          <p class="footer-desc">
            Thousands of developers are already
            building with Roanuz.
            <br class="desktop-br" />
            Now they're building AI-native
            cricket experiences.
          </p>
        </div>
        <a :href="calUrl" target="_blank" class="footer-cta" @click="onFooterCTAClick">
          <span>Book a Free 15-Min Demo</span>
          <svg
            class="cta-arrow"
            width="4"
            height="8"
            viewBox="0 0 4 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 0.5L3.5 4L0.5 7.5"
              stroke="white"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </a>
      </div>
      <div class="footer-legal">
        <p class="footer-copyright">
          &copy; Copyright Roanuz Softwares Private
          Limited. All rights reserved
        </p>
        <a
          href="https://www.cricketapi.com/legal/Privacy-Policy/"
          target="_blank"
          class="footer-terms"
        >Terms &amp; policy</a>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MCPBase',
  data() {
    return {
      headerScrolled: false,
    };
  },
  computed: {
    calUrl() {
      return this.getCalUrl();
    },
  },
  mounted() {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', this.handleScroll);
    }
    // Safari: dark status bar and body background for safe-area
    if (typeof document !== 'undefined') {
      this.originalBodyBg = document.body.style.backgroundColor;
      document.body.style.backgroundColor = '#171717';
      let themeTag = document.querySelector('meta[name="theme-color"]');
      if (!themeTag) {
        themeTag = document.createElement('meta');
        themeTag.name = 'theme-color';
        document.head.appendChild(themeTag);
      }
      themeTag.content = '#171717';
    }
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', this.handleScroll);
    }
    // Restore original body background
    if (typeof document !== 'undefined') {
      document.body.style.backgroundColor = this.originalBodyBg || '';
    }
  },
  methods: {
    handleScroll() {
      this.headerScrolled = window.scrollY > 10;
    },
    getUtmParams() {
      if (typeof window === 'undefined') return '';
      const params = new URLSearchParams(window.location.search);
      const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
      const utmParams = new URLSearchParams();
      utmKeys.forEach((key) => {
        if (params.has(key)) {
          utmParams.set(key, params.get(key));
        }
      });
      const str = utmParams.toString();
      return str ? `?${str}` : '';
    },
    getCalUrl() {
      return `https://cal.com/ashiey-joe-pfn0im${this.getUtmParams()}`;
    },
    trackCTAClick(location) {
      if (typeof window !== 'undefined' && window.dataLayer) {
        window.dataLayer.push({
          event: 'mcp_cta_click',
          cta_location: location,
          cta_text: 'Book a Free 15-Min Demo',
          page_path: '/mcp/',
        });
      }
    },
    onHeaderDemoClick() {
      this.trackCTAClick('header');
    },
    onFooterCTAClick() {
      this.trackCTAClick('footer');
    },
  },
};
</script>

<style lang="scss" scoped>
.mcp-page {
  font-family: var(--rz-hero-font);
  background: #171717;
  min-height: 100vh;
  min-height: 100dvh;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) scaleY(-1);
    width: size(1440);
    max-width: 100vw;
    height: size(900);
    background-image: url('https://assets.sports.dev.roanuz.com/ants/mcp/mcp-banner-bg.webp');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center bottom;
    z-index: 0;
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  h1, h2, h3, p {
    margin: 0;
    padding: 0;
  }

  .desktop-br {
    display: none;

    @media screen and (min-width: $breakpoint-md) {
      display: inline;
    }
  }

  // Header
  .mcp-header {
    position: sticky;
    top: 0;
    width: 100%;
    z-index: 100;
    border-bottom: size(1) solid transparent;
    background: transparent;
    transition: border-color 0.3s ease, background-color 0.3s ease;

    &.scrolled {
      background: #171717;
      border-bottom-color: #262626;
    }
  }

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: size(1200);
    margin: 0 auto;
    width: 100%;
    padding: size(16) size(20);
    box-sizing: border-box;

    @media screen and (min-width: $breakpoint-md) {
      padding: size(16) size(40);
    }

    @media screen and (min-width: $breakpoint-lg) {
      padding: size(20) 0;
    }
  }

  .logo-box {
    display: flex;
    align-items: center;

    .logo {
      height: size(32);
      width: auto;

      @media screen and (min-width: $breakpoint-md) {
        height: size(40);
      }
    }
  }

  .header-nav {
    display: flex;
    align-items: center;
    gap: size(8);

    @media screen and (min-width: $breakpoint-md) {
      gap: size(12);
    }
  }

  .nav-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: size(6);
    padding: size(6) size(10);
    border-radius: size(5);
    text-decoration: none;
    transition: opacity 0.2s ease;

    @media screen and (min-width: $breakpoint-md) {
      gap: size(8);
      padding: size(10) size(20);
    }

    &:hover {
      opacity: 0.85;
    }

    span {
      font-family: var(--rz-hero-font);
      font-weight: bold;
      font-size: size(11);
      line-height: size(14);
      white-space: nowrap;
      text-align: center;

      @media screen and (min-width: $breakpoint-md) {
        font-size: size(14);
        line-height: size(20);
      }
    }

    .nav-arrow {
      width: size(4);
      height: size(8);
      flex-shrink: 0;
    }

    &--outline {
      border: size(1) solid #fff;
      color: #fff;

      span {
        color: #fff;
      }
    }

    &--filled {
      background: var(--rs-cta-blue-color);
      border: size(1) solid var(--rs-cta-blue-color);

      span {
        color: var(--rs-white-color);
      }
    }
  }

  // Footer
  .mcp-footer {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: size(40) size(20) size(20);
    margin-top: size(60);
    box-sizing: border-box;
    min-height: size(380);
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background-image: url('https://assets.sports.dev.roanuz.com/ants/mcp/mcp-banner-bg.webp');
      background-size: 100% 100%;
      background-position: center;
      background-repeat: no-repeat;
      z-index: 0;
    }

    > * {
      position: relative;
      z-index: 1;
    }

    @media screen and (min-width: $breakpoint-md) {
      padding: size(40) size(40) size(20);
      margin-top: size(80);
      min-height: size(432);
    }

    @media screen and (min-width: $breakpoint-lg) {
      padding: size(40) 0 size(20);
      margin-top: size(120);
    }
  }

  .footer-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: size(32);
  }

  .footer-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: size(12);
    text-align: center;
  }

  .footer-title {
    font-family: var(--rz-hero-font);
    font-weight: 800;
    font-size: size(32);
    line-height: size(42);
    color: var(--rs-white-color);
    text-align: center;
    max-width: size(566);

    @media screen and (min-width: $breakpoint-md) {
      font-size: size(40);
      line-height: size(52);
    }

    @media screen and (min-width: $breakpoint-lg) {
      font-size: size(48);
      line-height: size(64);
    }
  }

  .footer-desc {
    font-family: var(--rz-hero-font);
    font-weight: 400;
    font-size: size(13);
    line-height: size(22);
    color: #e8e8e8;
    text-align: center;
    max-width: size(600);

    @media screen and (min-width: $breakpoint-lg) {
      font-size: size(14);
      line-height: size(24);
    }
  }

  .footer-cta {
    display: inline-flex;
    align-items: center;
    gap: size(10);
    background: var(--rs-cta-blue-color);
    color: var(--rs-white-color);
    font-family: var(--rz-hero-font);
    font-weight: 600;
    font-size: size(13);
    line-height: normal;
    padding: size(14) size(20);
    border-radius: size(8);
    text-decoration: none;
    white-space: nowrap;
    transition: opacity 0.2s;

    @media screen and (min-width: $breakpoint-md) {
      font-size: size(14);
      padding: size(20) size(32);
    }

    &:hover {
      opacity: 0.9;
    }
  }

  .footer-legal {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: size(10);
    text-align: center;
    width: 100%;
    padding-top: size(20);
    padding-bottom: size(80);

    @media screen and (min-width: $breakpoint-md) {
      padding-bottom: 0;
    }
  }

  .footer-copyright {
    font-family: 'Outfit', sans-serif;
    font-weight: 400;
    font-size: size(12);
    line-height: 1.4;
    color: var(--rs-black-color);
    max-width: size(250);

    @media screen and (min-width: $breakpoint-md) {
      font-size: size(14);
      line-height: 1.1;
    }
  }

  .footer-terms {
    font-family: 'Outfit', sans-serif;
    font-weight: 400;
    font-size: size(12);
    line-height: 1.4;
    color: var(--rs-black-color);
    text-decoration: underline;

    @media screen and (min-width: $breakpoint-md) {
      font-size: size(14);
      line-height: 1.1;
    }
  }
}
</style>
